module.exports = __webpack_public_path__ + "static/w3-datepicker-selected-01052fd41c55dff6252054565e577ecf.png";